<script setup lang="ts">
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

const { price } = defineProps<{
    price: number;
}>();
const emit = defineEmits<{
    close: [accepted: boolean];
}>();
</script>

<template>
    <mr-modal title="کمبود اعتبار" width="440px" @close="emit('close', false)">
        در صورتی که اعتبار شما کمتر از مبلغ بلیط‌های درخواستی باشد، تنها یک رزرو
        خودکار برای شما انجام خواهد شد.
        <template #footer>
            <div class="actions">
                <mr-button
                    full-width
                    variant="bordered"
                    @click="emit('close', false)"
                >
                    متوجه شدم
                </mr-button>
                <mr-button
                    :left-icon="faArrowLeft"
                    full-width
                    @click="emit('close', true)"
                >
                    شارژ آنلاین {{ formatMoney(price) }}
                </mr-button>
            </div>
        </template>
    </mr-modal>
</template>

<style scoped lang="scss">
.actions {
    display: flex;
    align-items: center;
    gap: 16px;
}
</style>
